import React, { useEffect, useRef, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MyRoute from "../Route/routes";
import { connect } from "react-redux";
import MyAuthRoute from "../Route/Authroute";
import routes from "../Route/routecoll";
import MenuNavLink from "./components/MenuNavLink";
import "./MainNav.css";
import { useLocation, useNavigate } from "react-router-dom";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import { Card, CardMedia, Grid, Switch } from "@mui/material";
import LoadingIndicator from "../loading-indicator/LoadingIndicator";
import AuthAction from "../../stores/Auth/AuthAction";
import NotificationsNoneTwoToneIcon from "@mui/icons-material/NotificationsNoneTwoTone";
// eslint-disable-next-line no-unused-vars
import { replace } from "lodash";
import AvatarIcon from "./components/AvatarIcon";
import influencerLogo from "../../components/logo/influencerLogo.png";

// ***************************************************************************************

const drawerWidth = 220;
const mapStateToProps = (state) => ({
  isRequesting: selectRequesting(state, [AuthAction.REQUEST_LOGIN]),
  auth: state.auth,
});
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});
const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,

  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const DrawerHeader = styled("div")(({ theme, open }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: `calc(100% - 16px - calc(${theme.spacing(8)}))`,
  zIndex: theme.zIndex.drawer + 1,
  boxShadow: theme.shadows,
  borderTopRightRadius: "10px",
  borderTopLeftRadius: "10px",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    // margin Left: drawerWidth,
    width: `calc(100% - ${drawerWidth}px - 15px)`,
    boxShadow: theme.shadows,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

// *****************************************************************************************************************************
function MiniDrawer(props) {
  const theme = useTheme();
  const { isRequesting } = props;

  let pathname = window.location.pathname;
  const navigate = useNavigate();
  const location = useLocation();

  let selectedRow = null;

  if (routes) {
    routes.data
      .filter((item) => item.path === pathname)
      .map((value) => (selectedRow = value.id));
  }

  React.useEffect((event) => {
    if (localStorage.getItem("Auth") === null) {
      navigate("/");
    }

    if (localStorage.getItem("Auth") === null) {
      navigate("/", { state: { from: location.pathname } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cookie = localStorage.getItem("Auth");

  const [open, setOpen] = React.useState(false);

  const [openInfluencer, setOpenInfluencer] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  // redirect to dashboard when you click on logo
  const logoClick = (item) => {
    navigate("/influencerDashboard");
  };

  // hanlde influencer
  const handleClickInfluencerSettings = () => {
    setOpenInfluencer(!openInfluencer);
  };

  let InfluencerArray = [];
  let InfluencerArrayMain = [];

  InfluencerArray = routes.data.filter((col) => col.category === "Influencer");
  InfluencerArray[0] && InfluencerArrayMain.push(InfluencerArray[0]);

  const returnInfluencerMenu = (routes) => {
    let filtered_route_main = [];
    let filtered_route = routes.data.filter((col) => {
      if (col.category === "Influencer") {
        filtered_route_main.push(col);
      }
    });

    return filtered_route_main.length > 0
      ? filtered_route_main.map((text, index) => {
          return (
            // <Collapse
            //   in={!openInfluencer}
            //   timeout="auto"
            //   unmountOnExit
            //   key={text.id + index}
            // >
            <ListItem
              component="div"
              disablePadding
              sx={{
                color: theme.palette.primary.main,
                display: text.hide === true ? "none" : "block",
              }}
              selected={selectedRow === text.id}
              onClick={(event) => {
                localStorage.setItem("pathIndex", text.id + index);
              }}
            >
              <MenuNavLink to={`${text.path}`}>
                <ListItemButton
                  title={text.title}
                  sx={
                    {
                      // minHeight: 48,
                      // justifyContent: open ? "initial" : "center",
                      // px: 2.5,
                    }
                  }
                >
                  <ListItemIcon
                    sx={{
                      // mr: open ? 3 : "auto",
                      // justifyContent: "center",
                      color: theme.palette.primary.main,
                      minWidth: "36px",
                      // marginRight: "12px",
                      // marginLeft: "12px",
                    }}
                  >
                    {text.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={text.title}
                    sx={{
                      color: theme.palette.primary.main,
                      opacity: open ? 1 : 0,
                      // fontSize: "14px",
                    }}
                  />
                </ListItemButton>
              </MenuNavLink>
            </ListItem>
            // </Collapse>
          );
        })
      : null;
  };

  const topHeaderRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const topHeaderHeight =
      topHeaderRef.current && topHeaderRef.current.offsetHeight;
    setHeaderHeight(topHeaderHeight);
  });

  return (
    // **************************************************************
    <React.Fragment>
      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes anima {
          0% {
            transform: translateY(-50px);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }
      `,
        }}
      />
      <LoadingIndicator isActive={isRequesting}>
        <Box
          sx={{ display: "flex"}}
          // className="bg-warning"
        >
          <CssBaseline />

          {props.auth.access_token === "" ||
          props.auth.access_token === undefined ? (
            <>
              <MyAuthRoute />
            </>
          ) : (
            <>
              <AppBar
                open={open}
                sx={{
                  // zIndex: (theme) => theme.zIndex.drawer,
                  backgroundColor: theme.palette.background.paper,
                  borderRadius: "8px",
                  scrollbarWidth: "none",
                  animation: `anima 0.3s ease-in-out`,
                }}
                ref={topHeaderRef}
              >
                <Toolbar>
                  <Grid
                    container
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid
                      item
                      container
                      // xl={5}
                      // lg={6.5}
                      // md={5.5}
                      // sm={6}
                      // xs={6}
                      sm={3}
                    >
                      <CardMedia
                        component="img"
                        sx={{
                          maxWidth: "80px",
                          // maxHeight: "55px",
                          height: "auto",
                        }}
                        image={influencerLogo}
                        onClick={logoClick}
                      />
                      <Grid
                        sm={1}
                        sx={{
                          borderRight: 1,
                          marginTop: "15px",
                          height: "55px",
                          borderRightColor: theme.palette.primary.contrastText,
                        }}
                      ></Grid>
                    </Grid>

                    <Grid
                      item
                      container
                      xl={4.5}
                      lg={5.5}
                      md={6.5}
                      sm={6}
                      xs={6}
                    >
                      <Grid
                        item
                        container
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        justifyContent="flex-end"
                        alignItems="center"
                      >
                        <Grid item xs={1} pt={1}>
                          <NotificationsNoneTwoToneIcon
                            style={{
                              color: theme.palette.primary.main,
                              fontSize: "30px",
                            }}
                          />
                        </Grid>
                        <Grid
                          sx={{
                            borderRight: 1,
                            marginRight: "15px",
                            height: "55px",
                            borderRightColor:
                              theme.palette.primary.contrastText,
                          }}
                        ></Grid>
                        <Grid item mr={3}>
                          <Box textAlign="right" px={5}>
                            <Typography
                              fontFamily={theme.typography.fontFamily}
                              sx={{ display: "flex", justifyContent: "end" }}
                              fontSize={{
                                xl: "20px",
                                lg: "18px",
                                md: "12px",
                                sm: "11px",
                                xs: "10px",
                              }}
                              // width="100%"
                              fontWeight={theme.typography.fontWeightRegular}
                              color={theme.palette.primary.main}
                            >
                              {routes.data.map((item) => {
                                if (item.path === pathname) {
                                  let text = item.title;
                                  if (item.title == "Logout")
                                    text = "Logging out...";
                                  const myArray = text.split(" ");
                                  return (
                                    <>
                                      {myArray.map((item) => (
                                        <div>
                                          <p className="dashboard-title">
                                            {item}
                                          </p>
                                        </div>
                                      ))}
                                    </>
                                  );
                                }
                              })}
                              {pathname.search("ticketDetails") !== -1 ? (
                                <p className="dashboard-title">Details</p>
                              ) : null}
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid
                          xl={1}
                          lg={1}
                          md={0.5}
                          sm={1}
                          xs={1}
                          // className="bg-dark"
                          display="flex"
                          justifyContent="center"
                          alignSelf="center"
                        >
                          <Grid
                            sm={1}
                            sx={{
                              borderRight: 1,
                              marginRight: "15px",
                              height: "55px",
                              borderRightColor:
                                theme.palette.primary.contrastText,
                            }}
                          ></Grid>
                          <Grid p={1}>
                            <div
                              onClick={() => {
                                navigate("/myProfile", {
                                  state: { from: location.pathname },
                                });
                                replace = true;
                              }}
                            >
                              <AvatarIcon />
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Toolbar>
              </AppBar>
              <Drawer
                variant="permanent"
                open={open}
                hideBackdrop={true}
                sx={{
                  "& .MuiDrawer-paper": { border: "none" },
                  "& .MuiPaper-root": {
                    backgroundColor: theme.palette.background.primary,
                  },
                  "& .MuiTypography-root": {
                    fontWeight: theme.typography.fontWeightBold,
                  },
                }}
              >
                <DrawerHeader
                  sx={{
                    ...(!open && {
                      display: "flex",
                      justifyContent: "center",
                      marginLeft: 1,
                    }),
                    marginBottom: 2,
                  }}
                >
                  <IconButton
                    color="primary"
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    sx={{
                      ...(open && { display: "none" }),
                    }}
                  >
                    <MenuIcon />
                  </IconButton>
                  <IconButton
                    onClick={handleDrawerClose}
                    sx={{ ...(!open && { display: "none" }) }}
                  >
                    {theme.direction === "rtl" ? (
                      <ChevronRightIcon />
                    ) : (
                      <ChevronLeftIcon />
                    )}
                  </IconButton>
                </DrawerHeader>
                {/* <Divider /> */}
                <List
                  sx={{
                    // selected and (selected + hover) states
                    "&& .Mui-selected, && .Mui-selected:hover": {
                      bgcolor: theme.palette.background.paper,
                    },
                  }}
                >
                  {/* ***************************** Influencer ***************************** */}
                  <ListItem disablePadding sx={{ display: "block" }}>
                    {returnInfluencerMenu(routes)}
                  </ListItem>

                  {/********************************Logout page************************************/}
                  <ListItem disablePadding sx={{ display: "block" }}>
                    {routes.data
                      .filter((col) => col.category === "Logout")
                      .map((text, index) => (
                        <ListItem
                          key={text.id + index}
                          disablePadding
                          sx={{
                            display: "block",
                          }}
                        >
                          <MenuNavLink to={`${text.path}`}>
                            <ListItemButton title={text.title}>
                              <ListItemIcon
                                sx={{
                                  color: theme.palette.primary.main,
                                  minWidth: "36px",
                                }}
                              >
                                {text.icon}
                              </ListItemIcon>
                              <ListItemText
                                primary={text.title}
                                sx={{
                                  color: theme.palette.primary.main,
                                  opacity: open ? 1 : 0,
                                }}
                              />
                            </ListItemButton>
                          </MenuNavLink>
                        </ListItem>
                      ))}
                  </ListItem>
                </List>
                {/* <Divider /> */}
              </Drawer>
              <Box
                component="main"
                sx={{
                  flexGrow: 1,
                  pl: 2,
                }}
              >
                <Box height={headerHeight}>
                <DrawerHeader />
              </Box>
                <MyRoute />
              </Box>
            </>
          )}
        </Box>
      </LoadingIndicator>
    </React.Fragment>
  );
}

export default connect(mapStateToProps)(MiniDrawer);
